/* global globalThis */
import { useEffect, useState } from "react";

// Shown until a fresher number is available. Update occasionally if the
// Places API isn't configured in Vercel.
export const FALLBACK_RATING = { rating: 5.0, count: 775 };

// The build bakes the latest numbers into the page as window.__GOOGLE_RATING__
// (see scripts/prerender.js); /api/google-rating refreshes them between deploys.
// globalThis is window in the browser and the Node global during pre-rendering.
function initialRating() {
    return globalThis.__GOOGLE_RATING__ || FALLBACK_RATING;
}

// One request per page load, shared by every component that shows the rating.
let request = null;
function loadRating() {
    if (!request) {
        request = fetch("/api/google-rating")
            .then((res) => (res.ok ? res.json() : null))
            .then((json) =>
                json && typeof json.count === "number" && typeof json.rating === "number"
                    ? { rating: json.rating, count: json.count }
                    : null
            )
            .catch(() => null);
    }
    return request;
}

export function useGoogleRating() {
    const [data, setData] = useState(initialRating);

    useEffect(() => {
        let cancelled = false;
        loadRating().then((fresh) => {
            if (!cancelled && fresh) setData(fresh);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    return data;
}

// 5 -> "5.0", 4.86 -> "4.9"
export const formatRating = (rating) => rating.toFixed(1);

// Rounded down to the nearest 25 so the copy reads "775+" rather than an exact count.
export const formatCount = (count) => `${Math.max(25, Math.floor(count / 25) * 25)}+`;
